import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { useNavigate, useLocation } from 'react-router-dom';

interface Appliances {
  name: string;
  image: string;
  price: number; // Ensure price is a number to avoid parsing issues
  slug: string;
}

const OwlCarouselComponent = () => {
  const navigate = useNavigate(); // Move inside component
  const [isLoadingg, setIsLoadingg] = useState(true); 
  const [appliancesItems, setAppliancesItems] = useState<Appliances[]>([]);
  const [appliancesheavyItems, setAppliancesHeavyItems] = useState<Appliances[]>([]);
  const [applianceslightItems, setAppliancesLightItems] = useState<Appliances[]>([]);
  const location = useLocation(); // Detect URL changes
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;


  // const appliancesheavyItems = [
  //   {
  //     slug: "item-1",
  //     image: sellmartLgImage,
  //     name: "Washing Machine",
  //     price: "15,000",
  //   },
  //   {
  //     slug: "item-2",
  //     image: sellmartBoschImage,
  //     name: "Refrigerator",
  //     price: "25,000",
  //   },
  //   {
  //     slug: "item-3",
  //     image: oppoImage,
  //     name: "Microwave Oven",
  //     price: "20,000",
  //   },
  //   {
  //     slug: "item-4", // Changed slug to make it unique
  //     image: whirlpoolImage,
  //     name: "Whirlpool Machine",
  //     price: "30,000",
  //   },
  //   // Add more appliances as needed
  // ];

  const handleClickAddToCart = (slug: any) => {
    navigate(`${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
  const fetchHeavy = async () => {
    setIsLoadingg(true);
    try {
      const response = await fetch(`${backendUrl}${version}home-banner/heavy_appliances`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: "include",
        mode:"cors"

      });
      const data = await response.json();

      // Ensure the response data is mapped to the Appliances type
      const formattedData: Appliances[] = data.data.appliances.map((item: any) => ({
        name: item.name,
        image: item.image,
        price: Number(item.price), // Ensure it's a number
        slug: item.slug,
      }));

      setAppliancesHeavyItems(formattedData);
    } catch (error) {
      //console.error('Error fetching banners:', error);
    }
  };

  const fetchElectric = async () => {
    setIsLoadingg(true);
    try {
      const response = await fetch(`${backendUrl}${version}home-banner/electric_appliances`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: "include",
        mode:"cors"

      });
      const data = await response.json();

      // Ensure the response data is mapped to the Appliances type
      const formattedData: Appliances[] = data.data.appliances.map((item: any) => ({
        name: item.name,
        image: item.image,
        price: Number(item.price), // Ensure it's a number
        slug: item.slug,
      }));

      setAppliancesItems(formattedData);
    } catch (error) {
      //console.error('Error fetching banners:', error);
    }
  };

  const fetchLight = async () => {
    setIsLoadingg(true);
    try {
      const response = await fetch(`${backendUrl}${version}home-banner/light_appliances`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: "include",
        mode:"cors"

      });
      const data = await response.json();

      // Ensure the response data is mapped to the Appliances type
      const formattedData: Appliances[] = data.data.appliances.map((item: any) => ({
        name: item.name,
        image: item.image,
        price: Number(item.price), // Ensure it's a number
        slug: item.slug,
      }));

      setAppliancesLightItems(formattedData);
    } catch (error) {
      //console.error('Error fetching banners:', error);
    }
  };
  fetchHeavy()
  fetchLight()
  fetchElectric()
}, [location]);


  const settings = {
    dots: false, // Enable navigation dots
    infinite: true, // Infinite scrolling
    speed: 700, // Transition speed in milliseconds
    slidesToShow: 4, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Autoplay interval in milliseconds
    responsive: [
      {
        breakpoint: 1024, // For screens less than 1024px
        settings: {
          slidesToShow: 3, // Show 3 slides
          slidesToScroll: 1, // Scroll 1 slide at a time
        },
      },
      {
        breakpoint: 768, // For screens less than 768px
        settings: {
          slidesToShow: 3, // Show 2 slides
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // For screens less than 480px
        settings: {
          slidesToShow: 3, // Show 1 slide
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="featured heavy">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="Appliances-top-home-page">Heavy Electronics</h2>
            <Slider {...settings}>
              {appliancesheavyItems.length > 0 ? (
                appliancesheavyItems.map((appliance, index) => (
                  <div className="item" key={index}>
                    <div className="fetur_pro_img">
                      <img src={appliance.image} alt={`${appliance.name}`} />
                    </div>
                    <div className="fetur_pro_img_description">
                      <p className="fe_pro_name">{appliance.name}</p>
                      <div className="wrap_div d-flex justify-content-between align-items-center">
                        <p className="fe_pro_price">
                          <span className="light_color_txt">Up to:</span>
                          <br className="m-none" />₹ {appliance.price}
                        </p>
                        <a
                          className="d-inline-block- web_view"
                          onClick={() => handleClickAddToCart(appliance.slug)}
                        >
                          Sell Now
                        </a>
                        <a
                          className="d-inline-block- mob_view"
                          onClick={() => handleClickAddToCart(appliance.slug)}
                        >
                          <i className="fa-solid fa-plus"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                null
              )}
            </Slider>


            <h2 className="Appliances-top-home-page">Light Electronics</h2>
            <Slider {...settings}>
              {applianceslightItems.length > 0 ? (
                applianceslightItems.map((appliance, index) => (
                  <div className="item" key={index}>
                    <div className="fetur_pro_img">
                      <img src={appliance.image} alt={`${appliance.name}`} />
                    </div>
                    <div className="fetur_pro_img_description">
                      <p className="fe_pro_name">{appliance.name}</p>
                      <div className="wrap_div d-flex justify-content-between align-items-center">
                        <p className="fe_pro_price">
                          <span className="light_color_txt">Up to:</span>
                          <br className="m-none" />₹ {appliance.price}
                        </p>
                        <a
                          className="d-inline-block- web_view"
                          onClick={() => handleClickAddToCart(appliance.slug)}
                        >
                          Sell Now
                        </a>
                        <a
                          className="d-inline-block- mob_view"
                          onClick={() => handleClickAddToCart(appliance.slug)}
                        >
                          <i className="fa-solid fa-plus"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                null
              )}
            </Slider>



            <h2 className="Appliances-top-home-page">Electronics and Gadgets</h2>
            <Slider {...settings}>
              {appliancesItems.length > 0 ? (
                appliancesItems.map((appliance, index) => (
                  <div className="item" key={index}>
                    <div className="fetur_pro_img">
                      <img src={appliance.image} alt={`${appliance.name}`} />
                    </div>
                    <div className="fetur_pro_img_description">
                      <p className="fe_pro_name">{appliance.name}</p>
                      <div className="wrap_div d-flex justify-content-between align-items-center">
                        <p className="fe_pro_price">
                          <span className="light_color_txt">Up to:</span>
                          <br className="m-none" />₹ {appliance.price}
                        </p>
                        <a
                          className="d-inline-block- web_view"
                          onClick={() => handleClickAddToCart(appliance.slug)}
                        >
                          Sell Now
                        </a>
                        <a
                          className="d-inline-block- mob_view"
                          onClick={() => handleClickAddToCart(appliance.slug)}
                        >
                          <i className="fa-solid fa-plus"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                null
              )}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OwlCarouselComponent;
